import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTotalCategory,
  fetchTotalMedia,
  fetchTotalMemberList,
  fetchTotalOnlineUser,
  
  fetchTotalVillageCount,
} from "./dataCount.api";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    totalVillageCount: 0,
    totalActiveCategories: 0,
    totalActiveMembers: 0,
    activeTotalUser: 0,
    totalMainActiveMembers: 0,
    totalActiveGalleryImages: 0,
    totalActiveVideos: 0,
    totalOnlineUsers: 0,
    loading: false,
    error: null,
  },
  reducers: {
    resetDashboardState: (state) => {
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch total surname count
    builder.addCase(fetchTotalVillageCount.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTotalVillageCount.fulfilled, (state, action) => {
      state.loading = false;
      console.log(action.payload, "=action.payload.data");
      state.totalVillageCount = action.payload;
    });
    builder.addCase(fetchTotalVillageCount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(fetchTotalOnlineUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTotalOnlineUser.fulfilled, (state, action) => {
      state.loading = false;
      state.totalOnlineUsers = action.payload.totalMemberCount;
    });
    builder.addCase(fetchTotalOnlineUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Fetch total active members count
    builder.addCase(fetchTotalMemberList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTotalMemberList.fulfilled, (state, action) => {
      state.loading = false;

      state.totalMainActiveMembers = action.payload.activeMainMemberCount || 0;
      state.totalActiveMembers = action.payload.activeMemberCount || 0;
      state.activeTotalUser = action.payload.activeTotalUser || 0;
    });
    builder.addCase(fetchTotalMemberList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Fetch total active category count
    builder.addCase(fetchTotalCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTotalCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.totalActiveCategories = action.payload.activeCategoryCount;
    });
    builder.addCase(fetchTotalCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Fetch total active media count (Gallery + Videos)
    builder.addCase(fetchTotalMedia.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTotalMedia.fulfilled, (state, action) => {
      state.loading = false;
      state.totalActiveGalleryImages =
        action.payload.totalActiveGalleryImages || 0;
      state.totalActiveVideos = action.payload.totalActiveVideos || 0;
    });
    builder.addCase(fetchTotalMedia.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetDashboardState } = dashboardSlice.actions;
export default dashboardSlice.reducer;
